import React, { useEffect, useState, useMemo } from "react";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setSegments,
  clearSegments,
} from "../../../../store/redux_auth/authSlice";
import SegmentMenu from "../../../../components/navegation/SegmentMenu";
import PersonalContent from "../../../../components/ui/account/PersonalContent";
import SecurityContent from "../../../../components/ui/account/SecurityContent";
import AccountManagement from "../../../../components/ui/account/AccountManagement";

const AccountSettings = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const currentSection = searchParams.get("section") || "personal";
  const [isMounting, setIsMounting] = useState(true);

  useEffect(() => {
    if (!searchParams.get("section")) {
      navigate("/account/settings?section=personal", { replace: true });
    }
  }, [searchParams, navigate]);

  const accountSegments = useMemo(
    () => [
      {
        path: "/account/settings?section=personal",
        text: "Personal",
        normalIcon: `${process.env.PUBLIC_URL}/images/icons/doc_grey.svg`,
        activeIcon: `${process.env.PUBLIC_URL}/images/icons/doc_blue.svg`,
        iconWidth: "24px",
        iconHeight: "24px",
      },
      {
        path: "/account/settings?section=security",
        text: "Security",
        normalIcon: `${process.env.PUBLIC_URL}/images/icons/key_grey.svg`,
        activeIcon: `${process.env.PUBLIC_URL}/images/icons/key_blue.svg`,
        iconWidth: "24px",
        iconHeight: "24px",
      },
      {
        path: "/account/settings?section=delete",
        text: "Account",
        normalIcon: `${process.env.PUBLIC_URL}/images/icons/user_grey.svg`,
        activeIcon: `${process.env.PUBLIC_URL}/images/icons/user_blue.svg`,
        iconWidth: "24px",
        iconHeight: "24px",
      },
    ],
    [],
  );

  useEffect(() => {
    dispatch(setSegments(accountSegments));
    return () => dispatch(clearSegments());
  }, [dispatch, accountSegments]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsMounting(false);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="main-content-area">
      <div className="content">
        <div className="ich-wrapper">
          <div className="internal-content-header">
            <SegmentMenu
              segments={accountSegments}
              currentPath={location.pathname + location.search}
              loading={isMounting}
            />
          </div>
        </div>

        <div className="internal-content-body">
          {currentSection === "personal" && <PersonalContent />}
          {currentSection === "security" && <SecurityContent />}
          {currentSection === "delete" && <AccountManagement />}
        </div>
      </div>
    </div>
  );
};

export default AccountSettings;
